

const _codecache = new WeakMap<object | Function>();

/**
 * Gets the source code of a function or the constructor of an object.
 */
export function getSourceCode(obj: object | Function | null | undefined): string | null {
    
    if (obj === null || obj === undefined) {
        return null;
    }

    const type = typeof obj;
    if (type !== "object" && type !== "function") {
        return null;
    }

    const cached = _codecache.get(obj);
    if (cached) {
        return cached;
    }

    if (!obj) {
        _codecache.set(obj, null);
        return null;
    }
    if (type === "function") {
        const funcString = obj.toString();
        _codecache.set(obj, funcString);
        return funcString;
    }
    else if (type === "object") {
        const prototype = Object.getPrototypeOf(obj);
        return getSourceCode(prototype.constructor);
    }
    return null;
}